import * as React from "react";
import * as cn from "classnames/bind";
import * as styles from "./cover-gallery.css";
import {
    getCoverImageId,
    getCustomCoverImageId,
    getBackCoverImageId,
    getCustomBackImageId,
    actionCreators,
} from "page/calendar/store";
import { actionCreators as burdeApiContentActionCreators } from "burde-api-content/store";
import { ImageResource, ImageDetails } from "burde";
import ZentaImagePickerV2 from "content/image/zenta-image-picker-v2";
import { connect } from "react-redux";
import { ApplicationState } from "store";
import { getResource } from "resource/store";

const cx = cn.bind(styles);

const tabGroupCn = () =>
    cx({
        tabGroup: true,
    });

const tabGroupLiCn = () =>
    cx({
        tabGroupLi: true,
    });

const tabItemCn = (isSelected: boolean) =>
    cx({
        categoryTabItem: true,
        categoryTabItemSelected: isSelected,
    });

type CoverGalleryProps = {
    coverImageId: number | null;
    backCoverImageId: number | null;
    customCoverImageId: number | null;
    customBackImageId: number | null;
    isBackPage?: boolean | null;
    getResource: (key: string) => string;
    imageResources: Array<ImageResource>;
    coverImage: ImageDetails | null;
    backCoverImage: ImageDetails | null;
} & typeof actionCreators &
    typeof burdeApiContentActionCreators;

interface CoverGalleryState {
    selectedTab: number;
}

class CoverGallery extends React.Component<
    CoverGalleryProps,
    CoverGalleryState
> {
    static defaultProps = {
        isBackPage: false,
    };

    state: CoverGalleryState = {
        selectedTab: 0,
    };

    private changeImage = (selectedImage: ImageDetails | null) => {
        const selectedImageId =
            selectedImage !== null ? selectedImage.id : null;

        if (this.props.isBackPage) {
            this.props.updateBackCoverImageId(selectedImageId);
            this.props.updateBackCoverColor(null);
            this.props.updateCustomBackImageId(null);
        } else {
            this.props.updateCoverImageId(selectedImageId);
            this.props.updateCoverColor(null);
            this.props.updateCustomCoverImageId(null);
        }
    };

    private getSelectedImage = () => {
        if (this.props.isBackPage && this.props.customBackImageId === null) {
            return this.props.backCoverImage;
        } else if (
            !this.props.isBackPage &&
            this.props.customCoverImageId === null
        ) {
            return this.props.coverImage;
        }

        return null;
    };

    public render() {
        const { selectedTab } = this.state;
        const { imageResources } = this.props;

        return (
            <div>
                {imageResources ? (
                    <div>
                        <ul className={tabGroupCn()}>
                            {imageResources.length > 1 &&
                                imageResources.map((item, index) => (
                                    <li
                                        key={item.resourceGroupTitle}
                                        className={tabGroupLiCn()}>
                                        <a
                                            className={tabItemCn(
                                                index === selectedTab,
                                            )}
                                            onClick={() =>
                                                this.setState({
                                                    selectedTab: index,
                                                })
                                            }>
                                            {item.resourceGroupTitle}
                                        </a>
                                    </li>
                                ))}
                        </ul>
                        <ZentaImagePickerV2
                            selectedImage={this.getSelectedImage()}
                            images={
                                imageResources[selectedTab] &&
                                imageResources[selectedTab].images
                                    ? imageResources[selectedTab].images
                                    : []
                            }
                            onClick={this.changeImage}
                        />
                    </div>
                ) : (
                    <div />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => ({
    getResource: (key: string) => getResource(state, { key }),
    coverImageId: getCoverImageId(state),
    backCoverImageId: getBackCoverImageId(state),
    customCoverImageId: getCustomCoverImageId(state),
    customBackImageId: getCustomBackImageId(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...burdeApiContentActionCreators,
};

export default connect(mapStateToProps, mapDispatchToProps)(CoverGallery);
